/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { AppState } from '../..';
import { NotificationModel } from './models';

const sortNotificationsByMostRecentFirst = (
  a: NotificationModel,
  b: NotificationModel,
) => {
  if (a.createdAt.toISOString() < b.createdAt.toISOString()) {
    return 1;
  }

  if (b.createdAt.toISOString() < a.createdAt.toISOString()) {
    return -1;
  }

  return 0;
};

export const selectIsNotificationsLoading = (state: AppState) =>
  state.notifications.isLoading;

export const selectAllNotifications = (state: AppState) =>
  Object.values(state.notifications.notifications).sort(
    sortNotificationsByMostRecentFirst,
  );

export const selectSelectedNotification = (state: AppState) =>
  state.notifications.selectedNotification;

export const getSelectedNotification = (state: AppState) =>
  state.notifications.notifications[
    state.notifications.selectedNotification || ''
  ];
